import {
  getPopularReviews,
  ICarReviewLink,
  UnsupportedPageType,
} from 'app/apiCalls/kentico';
import { IPageData } from 'app/utils/kentico';
import {
  getStaticPaths as getStaticPathsMainPage,
  getStaticProps as getStaticPropsMainPage,
  MainPage as MainPageContent,
} from 'app/containers/MainPage/MainPage';
import safeJsonStringify from 'safe-json-stringify';
import dataQuerySearch from 'app/shared/components/SearchQueryButton/SearchQueryButton.dataQuery';
import dataQueryPreviewBox from 'app/shared/components/ModelReview/SearchPreviewBox/SearchPreviewBox.dataQuery';
import { QueryCache } from 'react-query';
import { dehydrate } from 'react-query/hydration';

interface IReviewPageDataProps extends IPageData {
  popularModels: ICarReviewLink[];
}

const ReviewPage = (props: IReviewPageDataProps) => {
  return <MainPageContent {...props} />;
};

export async function getStaticProps(props) {
  const data = await getDataWithPrefetchedSearchQueryButton(props);

  if (data.notFound) {
    return data;
  }

  let popularModels = [];

  if (data.props.pageData.system.type === UnsupportedPageType.reviewPage) {
    const [make] = props.params.slug;
    popularModels = await getPopularReviews(make).catch(
      () => [] as ICarReviewLink[],
    );

    return getJSONWithoutCircularDependencyIssue({
      ...data,
      props: {
        ...data.props,
        popularModels,
      },
    });
  }

  return data;

  async function getDataWithPrefetchedSearchQueryButton(props) {
    const data = await getStaticPropsMainPage(props);
    if (!props.params?.slug) {
      return data;
    }

    const [make, model] = props.params.slug;
    const searchQueryParameters = `make=${make}&model=${model}`;
    const fallbackSearchQueryParameters = `make=${make}&modelFamily=${model}`;

    const queryCache = new QueryCache();
    const {
      fn: queryFn,
      name: queryName,
      options: queryOptions,
    } = dataQuerySearch;
    const {
      fn: queryPreviewFn,
      name: queryPreviewName,
      options: queryPreviewOptions,
    } = dataQueryPreviewBox;

    await queryCache.prefetchQuery(
      `${queryName}_${searchQueryParameters}`,
      () =>
        queryFn({ searchQueryParameters }).then(result =>
          !result.count && fallbackSearchQueryParameters
            ? queryFn({
                searchQueryParameters: fallbackSearchQueryParameters,
              })
            : result,
        ),
      queryOptions,
    );

    await queryCache.prefetchQuery(
      `${queryPreviewName}_${searchQueryParameters}`,
      () =>
        queryPreviewFn({ searchQueryParameters }).then(result =>
          !result.count && fallbackSearchQueryParameters
            ? queryPreviewFn({
                searchQueryParameters: fallbackSearchQueryParameters,
              })
            : result,
        ),
      queryPreviewOptions,
    );

    return {
      ...data,
      props: {
        ...data.props,
        dehydratedState: dehydrate(queryCache),
      },
    };
  }

  function getJSONWithoutCircularDependencyIssue(json) {
    //  This is a temporary solution!
    //
    //  Due to circular dependencies inside the Review (similar_models), the JSON.stringify
    //  cannot serialize/deserialize correctly.
    //
    //  Because of that, we use safe-json-stringify to be able to parse/stringify the JSON.

    return JSON.parse(safeJsonStringify(json));
  }
}

export async function getStaticPaths() {
  return getStaticPathsMainPage();
}

export default ReviewPage;
